<template>
  <div class="relative flex flex-col min-w-0 break-words w-full mb-4 p-4 shadow-lg rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Overall Activity Hours
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Activities Results of Students in Bachelor of Science
          </h2>
        </div>
      </div>
    </div>
    <div class="flex-auto w-full px-4">
      <select ref="plan_id" v-model="selectedPlan" @change="co_act_hour_sci"
        class="block w-full mt-3 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
        <option value="28">Radiological Technology</option>
        <option value="29">Physical Therapy</option>
        <option value="30">Emergency Medical Operation</option>
      </select>
      <select ref="class_id" v-model="selectedClass" @change="co_act_hour_sci"
        class="block w-full mt-3 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
        <option value="1">Year 1</option>
        <option value="2">Year 2</option>
        <option value="3">Year 3</option>
        <option value="4">Year 4</option>
      </select>
    </div>
    <div class="flex-auto w-full ">
      <div class="relative flex flex-col min-w-1 break-words bg-white w-full">
        <div class="px-4 py-5 flex-auto ">
          <div class="tab-content tab-space ">
            <div class="relative">
              <canvas ref="chartCanvas" class="disable-mouse"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Bar } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import api from './../../services/student_services';

export default {
  name: 'App',
  data() {
    return {
      plan_id: undefined,
      class_id: undefined,
      selectedPlan: "28", // ค่าเริ่มต้นที่ถูกเลือก
      selectedClass: "4", // ค่าเริ่มต้นที่ถูกเลือก
      student_sci_arr: [],
      data_id: {
        "program": '',
        "class_year": ''
      },
    };
  },
  methods: {
    async co_act_hour_sci() {
      this.data_id = {
        "program": this.selectedPlan,
        "class_year": this.selectedClass
      }

      api.co_act_hour_sci(this.data_id).then(async (result) => {
        this.student_sci_arr = result.data;
        //console.log(this.student_sci_arr)       

        this.$nextTick(function () {
          const ctx = this.$refs.chartCanvas.getContext('2d');

          const data_sum_normal_M = [];
          const data_sum_normal_F = [];
          const data_sum_delay_M = [];
          const data_sum_delay_F = [];

          this.student_sci_arr.forEach((student_list) => {
            data_sum_normal_M.push(student_list.sum_normal_M);
            data_sum_normal_F.push(student_list.sum_normal_F);
            data_sum_delay_M.push(student_list.sum_delay_M);
            data_sum_delay_F.push(student_list.sum_delay_F);
          });

          new Bar(ctx, {
            data: {
              labels: [
                '0 Hour',
                '1 - 50 Hours',
                '51 - 100 Hours',
                '101 - 150 Hours',
                '150 > Hours',
              ],
              datasets: [
                {
                  label: 'Male (Regular)',
                  data: data_sum_normal_M,
                  backgroundColor: "#154066",
                  stack: 'Stack 0',
                },
                {
                  label: 'Male (Delay)',
                  data: data_sum_delay_M,
                  backgroundColor: "#f39c12",
                  stack: 'Stack 0',
                },
                {
                  label: 'Female (Regular)',
                  data: data_sum_normal_F,
                  backgroundColor: "#36A2EB",
                  stack: 'Stack 1',
                },
                {
                  label: 'Female (Delay)',
                  data: data_sum_delay_F,
                  backgroundColor: "#f39c12",
                  stack: 'Stack 1',
                },
              ],
            },
            options: {
              responsive: true,
              interaction: {
                intersect: false,
              },
              scales: {
                x: {
                  stacked: false
                },
                y: {
                  stacked: true,
                  beginAtZero: true
                }
              },
              plugins: {
                datalabels: {
                  color: '#FFFFFF',
                  formatter: (data) => {
                    return data != 0 ? data : '';
                  }
                }
              }
            },
            plugins: [ChartDataLabels],
          });
        });
      });
    },
  }, created: async function () {
    await this.co_act_hour_sci()
  },
};
</script>

<style scoped>
.disable-mouse {
  pointer-events: none;
}
</style>
